/**
 * @param {Object} types
 * @returns {Object of Functions} actions to be fired.
 */
const bindTypesToActions = ( types = {} ) => {
    let actions = {};
    for(let prop in types){
        actions[ prop ] = ( payload = {} ) => ( { type: types[ prop ], payload } );
    }
    return actions;
}

export {
    bindTypesToActions
}